<template>
  <transition name="slide-in-top">
    <div
      v-show="show"
      class="z-iosPrompt fixed bottom-0 m-4 p-4 bg-white border shadow-md"
    >
      <div class="flex justify-between items-start">
        <p class="mb-2">
          Install <span class="font-medium">Landscape Monitor</span> on your
          device for quick and easy access.
        </p>
        <lm-icon-button icon="close" class="ml-2" @click="close" />
      </div>
      <p>
        Tap <lm-icon icon="iosMenu" class="mx-2" /> and then select "Add to Home
        Screen"
      </p>
      <label class="flex text-xs">
        <input v-model="doNotShowAgain" type="checkbox" class="" />&nbsp;Do not
        show again
      </label>
    </div>
  </transition>
</template>

<script>
import LmIcon from '@/components/ui/LmIcon'
import {mapGetters} from 'vuex'
import LmIconButton from '@/components/ui/LmIconButton'
import {LocalStorage} from '@/lib/definitions'

const userAgent = window.navigator.userAgent.toLowerCase()
export default {
  name: 'LmA2HSPrompt',
  components: {LmIcon, LmIconButton},
  props: {},
  data() {
    return {
      show: false,
      doNotShowAgain: false
    }
  },
  computed: {
    ...mapGetters({
      iOSPromptAllowed: 'preferences/iOSPromptAllowed'
    })
  },
  mounted() {
    if (
      this.iOSPromptAllowed &&
      this.timeWindowFinished() &&
      this.isSafari() &&
      this.isIOSDevice() &&
      !this.isInStandaloneMode()
    ) {
      setTimeout(() => {
        this.show = true
      }, 3000)
    }
  },
  methods: {
    isSafari() {
      // eslint-disable-next-line
      return !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)
    },
    isIOSDevice() {
      return /iphone|ipad|ipod/.test(userAgent)
    },
    isInStandaloneMode() {
      return 'standalone' in window.navigator && window.navigator.standalone
    },
    timeWindowFinished() {
      // Do not show if it was closed before 7 days
      const lastPromptClosed = localStorage.getItem(LocalStorage.PROMPT_IOS)
      if (!lastPromptClosed) return true
      const diffToDays = (Date.now() - lastPromptClosed) / 1000 / 60 / 60 / 24
      return diffToDays > 7
    },
    close() {
      if (this.doNotShowAgain) {
        this.$store.dispatch('preferences/save', {
          iOSPromptAllowed: false
        })
      }
      this.show = false
      localStorage.setItem(LocalStorage.PROMPT_IOS, Date.now())
    }
  }
}
</script>
